import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import HomePage from './pages/HomePage';
import CareersPage from './pages/CareersPage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import TeamPage from './pages/TeamPage';
import SafetyPage from './pages/SafetyPage';
import SiteIndexPage from './pages/SiteIndexPage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminOverview from './pages/admin/AdminOverview';
import AdminApplications from './pages/admin/AdminApplications';
import AdminApplicationDetail from './pages/admin/AdminApplicationDetail';
import AdminContacts from './pages/admin/AdminContacts';
import AdminContactDetail from './pages/admin/AdminContactDetail';
import AdminAuthGuard from './components/admin/AdminAuthGuard';
import './App.css';

function Guarded({ element }) {
  return <AdminAuthGuard>{element}</AdminAuthGuard>;
}

function App() {
  return (
    <Router>
      <a href="#main-content" className="skip-link" data-testid="skip-to-content">
        Skip to main content
      </a>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/safety" element={<SafetyPage />} />
        <Route path="/site-index" element={<SiteIndexPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<Guarded element={<AdminOverview />} />} />
        <Route path="/admin/applications" element={<Guarded element={<AdminApplications />} />} />
        <Route path="/admin/applications/:id" element={<Guarded element={<AdminApplicationDetail />} />} />
        <Route path="/admin/contacts" element={<Guarded element={<AdminContacts />} />} />
        <Route path="/admin/contacts/:id" element={<Guarded element={<AdminContactDetail />} />} />
      </Routes>
    </Router>
  );
}

export default App;
